import { helpers, required, requiredIf } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import Validator from "~/utils/validator";

// get generic validation locale merged with theme defined validation locale
const { locale } = await useLocale("validation", null, true);

export default {
  employerName: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  employerAddress: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  employerStreetNumber: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  employerCity: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  employerPostalCode: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  employerPhone: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    validPhone: helpers.withMessage(
      () => locale?.value?.invalid_phone ?? validationJson.invalid_phone,
      Validator.phone,
    ),
    notPersonalPhone: helpers.withMessage(
      () => locale?.value?.personal_phone ?? validationJson.invalid_phone,
      (value: string|null, { noPersonalPhoneRule }: any) => {
        if (!noPersonalPhoneRule) return true;
        return Validator.notPersonalPhone(value)
      }
    )
  },
  employeeLoan: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: string, { showEmployeeLoan }: any) {
        return !!(showEmployeeLoan ?? false);
      }),
    ),
  },
  familyMemberCount: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: number, { showFamilyMemberCount }: any) {
        return showFamilyMemberCount;
      }),
    ),
    nonZero: Validator.nonZeroIf("showFamilyMemberCount"),
  },
  employedFamilyMemberCount: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: number, { familyMemberCount }: any) {
        return familyMemberCount.value > 1;
      }),
    ),
    nonZero: Validator.nonZeroIf("showFamilyMemberCount"),
  },
};
